/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-array-index-key */
import {
  Button,
  IconButton,
  Steps,
  Typography,
} from '@wisecare-tech/design-system-web';
import { Header } from 'presentation/components/header';
import { useTopicConfig } from 'presentation/hooks/sac/createTopicConfig';
import React, { ReactNode, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useHistory } from 'react-router';
import { CreateTopicConfigSchema } from 'validation/sac/createTopConfig';
import Translator from '~/presentation/components/i18n/Translator';
import { Container, SubHeader } from '../Sac/styles';
import { CreateTopicConfigStepOne } from './StepOne';
import { AttendantsStepTwo } from './StepTwo';
import { Footer, FormButtonContainer, SacForm, StepContainer } from './styles';

export const CreateSacTopic: React.FC = () => {
  const { loading, submitValues, handleBackStep } = useTopicConfig();

  const {
    control,
    watch,
    handleSubmit,
    formState: { isValid },
  } = useFormContext<CreateTopicConfigSchema>();

  const history = useHistory();

  const step = watch('step');

  const steps = useMemo(
    () => [
      {
        active: step === 1,
        completed: step > 1,
        label: 'Configurações gerais',
      },
      {
        active: step === 2,
        completed: step > 2,
        label: 'Atendentes',
      },
    ],
    [step],
  );

  const renderForm: Record<number, ReactNode> = {
    1: <CreateTopicConfigStepOne />,
    2: <AttendantsStepTwo />,
  };

  if (loading) return <div>loading...</div>;

  return (
    <Container>
      <div style={{ position: 'sticky', top: 0, zIndex: 999 }}>
        <Header title="teste" />

        <SubHeader>
          <IconButton
            id="button-back"
            variant="primary"
            icon="arrow_back"
            size="md"
          />

          <Typography id="subheader_title" variant="b2_14semibold">
            AtendeFácil
          </Typography>
        </SubHeader>
      </div>
      <div style={{ height: '100%', overflow: 'auto' }}>
        <SacForm
          onSubmit={handleSubmit(submitValues, data => console.log(data))}
        >
          <StepContainer>
            <Steps steps={steps} />
            {renderForm[step]}
          </StepContainer>
          <Footer>
            <Button
              type="button"
              variant="outlinedDestructive"
              size="lg"
              onClick={() => history.goBack()}
            >
              {Translator('Cancelar')}
            </Button>
            <FormButtonContainer>
              {step > 1 && (
                <Button
                  type="button"
                  variant="outlined"
                  size="lg"
                  onClick={handleBackStep}
                >
                  {Translator('Voltar')}
                </Button>
              )}
              <Button
                type="submit"
                variant="primary"
                size="lg"
                disabled={!isValid}
              >
                {Translator('Avançar')}
              </Button>
            </FormButtonContainer>
          </Footer>
        </SacForm>
      </div>
    </Container>
  );
};
